<template>
  <div>
    <form v-if="currentCountry">

      <v-row>
        <v-col class="mt-4" cols="12" md="3">
          <h4>Logo</h4>
        </v-col>
        <v-col cols="12" md="9">
          <ProfilePhoto style="padding: 2px 0px !important" class="" />
        </v-col>
      </v-row>
      <v-divider class="my-2"></v-divider>
      <v-row class="pt-6">
        <v-col cols="12" md="3"><strong>{{
          $t("accountSettings.accountData.nameTitle")
        }}</strong> *</v-col>
        <v-col cols="12" md="9"><v-text-field disabled @input="v$.form.company.$touch()" @blur="v$.form.company.$touch()"
            :error-messages="companyErrors" required v-model="form.company" outlined></v-text-field></v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row class="pt-6">
        <v-col cols="12" md="3"><strong>País</strong> *</v-col>
        <v-col cols="12" md="9"><v-select disabled :items="assets.countries" item-text="name" item-value="code"
            :value="form.location" outlined>
            <template #append>
              <v-img max-width="22" max-height="22" style="margin: 4px 8px 0 -5px;" contain
                :src="require(`@/assets/flags/${currentCountry2.flag}`)"></v-img>
            </template>
            <template v-slot:item="slotProps">
              <v-img max-width="22" max-height="22" class="mr-3" contain
                :src="require(`@/assets/flags/${slotProps.item.flag}`)"></v-img>
              {{ slotProps.item.name }}
            </template>

          </v-select></v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row class="pt-6">
        <v-col cols="12" md="3"><strong>{{ currentCountry.companyDocument }}</strong> *</v-col>
        <v-col cols="12" md="9"><v-text-field disabled v-model="form.document" v-mask="currentCountry.companyDocumentMask"
            outlined></v-text-field></v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row class="pt-6">
        <v-col class="mt-2" cols="12" md="3"><strong>{{ $t('accountSettings.personalData.phoneTitle') }}</strong>
          *</v-col>
        <v-col cols="12" md="9" class="d-flex">
          <v-select class="--flag mr-2" :items="assets.countries" item-text="name" item-value="code" v-model="location"
            outlined>
            <template #append>
              <v-img max-width="22" max-height="22" style="margin: 4px 8px 0 -5px;" contain
                :src="require(`@/assets/flags/${currentCountry.flag}`)"></v-img>
            </template>
            <template v-slot:item="slotProps">
              <v-img max-width="22" max-height="22" class="mr-3" contain
                :src="require(`@/assets/flags/${slotProps.item.flag}`)"></v-img>
              {{ slotProps.item.name }}

            </template>

          </v-select>
          <v-text-field outlined v-model="form.phoneNumber" label="Telefone" @input="v$.form.phoneNumber.$touch()"
            @blur="v$.form.phoneNumber.$touch()" :error-messages="phoneErrors" v-mask="currentCountry.phoneMasks"
            :placeholder="currentCountry.phonePlaceholder"></v-text-field>
        </v-col>
      </v-row>
      <div class="d-flex">
        <v-spacer></v-spacer>
        <v-btn :disabled="disabledBtn" class="white--text" color="#075f2e" large elevation="0" @click="submit"
          :loading="loading"> {{ this.$t('common.save') }}</v-btn>
      </div>

    </form>

    <v-snackbar style="top: 70px" top right v-model="success.show" color="green">
      <span v-html="success.text"></span>
      <v-btn icon @click="success.show = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-snackbar style="top: 70px" top right v-model="errors.show" color="red">
      <span v-html="errors.text"></span>
      <v-btn icon @click="errors.show = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
    <!-- <pre>{{ v$ }}</pre> -->
  </div>
</template>

<script>
import ProfilePhoto from "./ProfilePhoto.vue";
import useVuelidate from "@vuelidate/core";
import { mapActions } from "vuex";
import { required, minLength, maxLength } from "@vuelidate/validators";
// import validations from "@/plugins/validations";
// const isCNPJ = (value) => validations.isCNPJ(value);
// const isRUC = (value) => {
//   const res = validations.isValidPeruRUC(value)
//   return validations.isValidPeruRUC(value)
// };

export default {
  name: "ProfileForm",
  components: { ProfilePhoto },
  setup() {
    return { v$: useVuelidate() };
  },

  validations() {
    return {
      form: {
        company: { required, minLength: minLength(2) },
        phoneNumber: { required, minLength: minLength(this.currentCountry.phonePlaceholder.length) },
        // document: { required, validFormat: this.location == 'PER' ? isRUC : isCNPJ },
      },
    };
  },

  data() {
    return {
      location: "BRA",
      assets: {
        countries: [
          {
            name: 'Brasil',
            currency: 'BRL',
            code: 'BRA',
            flag: 'bra.svg',
            lang: 'es',
            phoneMasks:'+55 (##) ####-#####',
            phonePlaceholder: '+55 (00) 0000-0000',
            phoneMinLength: 18,
            index: 0,
            personalDocument: 'CPF',
            personalDocumentMask: '###.###.###-##',
            companyDocument: 'CNPJ',
            companyDocumentMask: '##.###.###/####-##',
            zipCodeMask: '#####-###'
          },

          {
            name: 'Chile',
            currency: 'CHI',
            code: 'CHI',
            flag: 'chi.svg',
            lang: 'es',
            phoneMasks: '+56 ## ##-###-###',
            phonePlaceholder: '+56 00 0-000-000',
            phoneMinLength: 15,
            index: 1,
            personalDocument: 'RUN',
            personalDocumentMask: '##.###.###-#',
            companyDocument: 'RUT',
            companyDocumentMask: '##.###.###-#',
            zipCodeMask: '### ####'
          },
          {
            name: 'Colombia',
            currency: 'COL',
            code: 'COL',
            flag: 'col.svg',
            lang: 'es',
            phoneMasks: '+57 ##-########',
            phonePlaceholder: '+57 00-0000000',
            phoneMinLength: 15,
            index: 2,
            personalDocument: 'RUT',
            personalDocumentMask: '##.###.###-#',
            companyDocument: 'NIT',
            companyDocumentMask: '##.###.###-#',
            zipCodeMask: '######'
          },

          {
            name: 'Mexico',
            currency: 'MEX',
            code: 'MEX',
            flag: 'mex.svg',
            lang: 'es',
            phoneMasks: '+52 ### #######',
            phonePlaceholder: '+52 000 0000000',
            phoneMinLength: 15,
            index: 3,
            personalDocument: 'CURP',
            personalDocumentMask: 'AAAA######AAAAAA##',
            companyDocument: 'RUT',
            companyDocumentMask: '##.###.###-#',
            zipCodeMask: '#####'
          },
          {
            name: 'Peru',
            currency: 'SOL',
            code: 'PER',
            flag: 'per.svg',
            lang: 'es',
            phoneMasks: '+51 ### ### ###',
            phonePlaceholder: '+51 000 000 000',
            phoneMinLength: 14,
            index: 4,
            personalDocument: 'DNI',
            personalDocumentMask: '########-#',
            companyDocument: 'RUC',
            companyDocumentMask: '###########',
            zipCodeMask: '#####'
          },

        ]
      },

      success: {
        text: "",
        show: false,
      },
      form: {
        location: "",
        company: "",
        phoneNumber: "",
        document: "",
        tradingName: "",
        displayName: "",
        ie: null,
        ccm: null,
        id: null,
        logo: "",
      },
      phoneNumber: {

      },
      phoneNumberIndex: null,
      loading: false,
      showing: null,
      id: null,
      ccm: null,
      ie: null,
      tradingName: this.$root.auth.profile.tradingName,
      name: this.$root.auth.profile.name,
      displayName: this.$root.auth.profile.displayName,
      document: this.$root.auth.profile.document,
      // form: {
      //   contact: "(00)0000-0000",
      //   id: null,
      //   ccm: null,
      //   ie: null,
      //   tradingName: this.$root.auth.profile.tradingName,
      //   name: this.$root.auth.profile.name,
      //   displayName: this.$root.auth.profile.displayName,
      //   document: this.$root.auth.profile.document,
      // },
      messages: {
        show: false,
        text: "",
      },
      errors: {
        show: false,
        text: "",
      },
    };
  },

  computed: {
    currentCountry2() {

      return this.assets.countries.find(country => country.code == this.currentCountry.code)
    },
    currentCountry() {
      return this.assets.countries.find(country => country.code == this.location)
    },
    disabledBtn() {
      return this.v$.$anyDirty && this.v$.$invalid
    }
    ,
    phoneMask() {
      const result = this.currentCountry.phoneMasks;
      return result;
    },

    companyErrors() {
      const errors = [];
      if (!this.v$.form.company.$dirty) return errors;
      this.v$.form.company.minLength.$invalid &&
        errors.push(
          this.$t("accountSettings.accountData.err.minLengthName", { count: 6 })
        );
      this.v$.form.company.required.$invalid &&
        errors.push(this.$t("accountSettings.accountData.err.required"));
      return errors;
    },
    phoneErrors() {
      const errors = [];
      if (!this.v$.form.phoneNumber.$dirty) return errors;
      this.v$.form.phoneNumber.required.$invalid && errors.push(this.$t("accountSettings.accountData.err.requiredPhone"));
      this.v$.form.phoneNumber.minLength.$invalid && errors.push(this.$t("accountSettings.personalData.err.minLengthPhone"));
      return errors;
    },
    documentErrors() {
      const errors = [];
      if (!this.v$.form.document.$dirty) return errors;
      this.v$.form.document.required.$invalid &&
        errors.push(
          this.$t("auth.form.document.errors.required", { doc: "CNPJ" })
        );
      this.v$.form.document.validFormat.$invalid &&
        errors.push(
          this.$t("auth.form.document.errors.invalid", { doc: "CNPJ" })
        );
      return errors;
    },
  },
  created() {

  },
  mounted() {

    this.form.company = this.$root.auth.profile.displayName
    this.form.document = this.$root.auth.profile.document
    this.tradingName = this.$root.auth.profile.tradingName
    this.displayName = this.$root.auth.profile.displayName
    this.form.phoneNumber = this.$root.auth.profilePhones.length ? this.$root.auth.profilePhones[0].contact : ''
    if (this.form.phoneNumber) {
        const first = `${this.form.phoneNumber[1]}${this.form.phoneNumber[2]}`;
        console.log('first', first)
        switch (first) {
          case '56': case 56: this.location = 'CHI'; break;
          case '57': case 57: this.location = 'COL'; break;
          case '52': case 52: this.location = 'MEX'; break;
          case '51': case 51: this.location = 'PER'; break;
          case '55': case 55: default: this.location = 'BRA'; break;

        }
      }
    // const phoneNumber = this.$root.auth.user.phones.find(phone => phone.profileId == this.$root.auth.plan.profileId)
    // const phoneNumberIndex = this.$root.auth.user.phones.findIndex(phone => phone.profileId == this.$root.auth.plan.profileId)
    if(!this.form.phoneNumber){
      this.location = this.$root.auth.profile.location
    }
    this.form.location = this.$root.auth.profile.location

   
    // this.form.phoneNumber = phoneNumber.contact
    // this.phoneNumber = phoneNumber
    // this.phoneNumberIndex = phoneNumberIndex
    // this.form.logo = this.account.logo ? this.account.logo : `https://via.placeholder.com/128x128/${this.$root.currentStore.config.primaryColor.split('#')[1]}/ffffff.jpg?text=${this.account.company[0]}`
  },

  methods: {
    ...mapActions("snackbar", ["showSnack"]),
    showSave() {
      this.success.text = $t(
        "accountSettings.personalData.success.changedName"
      );
      this.success.show = true;
    },
    submit() {
      this.loading = true
      const contactForm = {
        name: this.$root.auth.user.name,
        contact: this.form.phoneNumber,
        contactTypeId: 2,
      }
      console.log('saving contact form', contactForm)

      if (this.$root.auth.profilePhones.length && this.$root.auth.profilePhones[0] && this.$root.auth.profilePhones[0].id) {
        this.$axios.put(`contacts/${this.$root.auth.profilePhones[0].id}`, contactForm).then((contact) => {

          const user = JSON.parse(JSON.stringify(this.$root.auth))
          user.profilePhones = [{ contact: this.form.phoneNumber, id: contact.data.data.id, name: this.$root.auth.profile.displayName }];
          localStorage.setItem("auth", JSON.stringify(user));
          this.showSnack({
            text: this.$t('accountSettings.personalData.success.save'),
            color: "success",
            timeout: 4000,
            icon: "mdi-check",
          });
          this.loading = false;

        }, (err) => {
          console.log('ERR', err)
        })
      }
      else {
        this.$axios.post(`contacts`, contactForm).then((contact) => {

          const user = JSON.parse(JSON.stringify(this.$root.auth))
          user.profilePhones = [{ contact: this.form.phoneNumber, id: contact.data.data.id }];

          localStorage.setItem("auth", JSON.stringify(user));
          this.showSnack({
            text: this.$t('accountSettings.personalData.success.save'),
            color: "success",
            timeout: 4000,
            icon: "mdi-check",
          });
          this.loading = false;

        }, (err) => {
          console.log('ERR', err)
        })
        // })
      }
    }
  }
}
            //   },

</script>
